"use client";
import { usePathname } from "next/navigation";

interface IOneTrustManualScriptProps {
  xHost?: string;
  useOneTrust?: boolean;
}

export function OneTrustManualScript(props: IOneTrustManualScriptProps) {
  const pathname = usePathname();
  const enableOneTrust = pathname?.includes("/search-modal") ?
    false :
    props?.useOneTrust;

  // Custom: Determine host and OneTrust values
  const xHost = props?.xHost // ctx.req?.headers?.['x-host'] || '';
  let oneTrustScript = {
    src: 'https://cdn.cookielaw.org/consent/c37345a0-f820-4777-9d9d-dfc31170677a/otSDKStub.js',
    data: 'c37345a0-f820-4777-9d9d-dfc31170677a'
  };

  if (xHost?.includes?.('directvdeals.com')) {
    oneTrustScript = {
      src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
      data: '01976077-3ced-7b57-98e6-c3a71c79c392'
    };
  }

  return (
    <>
      {/* Plain <script>, not next/script: every strategy except beforeInteractive
          is moved to document.body at hydration. Mirrors pages/_document.tsx. */}
      {enableOneTrust && (
        <script
          async
          data-domain-script={oneTrustScript.data}
          id="onetrust-tag"
          src={oneTrustScript.src}
          type="text/javascript"
        />
      )}
    </>
  );
}

export default OneTrustManualScript;
